export default __webpack_public_path__ + "static/media/CW__3568.cefb0afe.jpg";